import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';

export default class AccountBillingDetailsService {
    static getPolicyBillingSummary(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingData'), 'getPolicyBillingSummary', [policyNumber], additionalHeaders);
    }

    // TDIC - Added - Following method to get Document details
    static getDocumentDetails(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('billingDocument'), 'getDocumentDetails', [policyNumber], additionalHeaders);
    }

    // TDIC - Added - Following method to get Billing Document link
    static getBillingDocumentLink(documentID, sessionID) {
        const downloadURL = getProxiedServiceUrl('billingDocumentDownload');
        return fetch(`${downloadURL}/${documentID}?token=${sessionID}`);
    }

    // TDIC - Added - Retrieves Holiday Information
    static getHolidaysOnOrAfterRequestDate(onOrAfterDate, additionalHeaders = {}) {
        let dateToUse = onOrAfterDate;
        if (dateToUse instanceof Date) {
            dateToUse = {
                year: onOrAfterDate.getFullYear(),
                month: onOrAfterDate.getMonth(),
                day: onOrAfterDate.getDate()
            };
        }
        return JsonRPCService.send(getProxiedServiceUrl('holiday'), 'getHolidaysOnOrAfterRequestDate', [dateToUse], additionalHeaders);
    }
}
